import React from 'react';

const Information = () => {
	return <div></div>;
};

export default Information;
